import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Query } from '../op-types';

export function createResearchReportQueries(client: StoxlyClient) {
  return createQueryKeys('researchReports', {
    // ['researchReports', 'export', id, { query }]
    export: (id: string, query?: Query<'researchReportsExport'>) => ({
      queryKey: [id, { query }],
      queryFn: ({ signal }) =>
        client.researchReportsExport({ params: { id }, queries: query, signal }),
    }),
  });
}
